


























































































































































































































import { QInput, QCard, QCardSection, QForm, QSelect, QBtn, QSeparator, QLinearProgress, QCheckbox, QItem, QItemSection, QOptionGroup } from 'quasar';
import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import axios from 'axios';
import { GetEnoteZrss, PostPrijavnica, PostPrijavnicaStudijske, GetSeminarjiStudijske } from '../../api';
import { IEnotaZrss, ISeminarSS } from '@/model';
import Checkmark from '../layout/checkmark.vue';



const getEmptyData = () => ({
    ustanova: {
        naziv: null,
        naslov: null,
        posta: null,
        kraj: null,
        davcna: null,
        enota_zrss: null,
    },
    udelezenec: {
        ime: null,
        priimek: null,
        email: null,
        email1: null,
        letoRojstva: null
    },
    seminar: {
        nivo: null,
        predmet: null,
    },
    seminarId: null
});

function formatSkupinaOpomba(x: ISeminarSS) {
    const data = [x.tip];    
    if(x.lokacija)
        data.push(x.lokacija);
    if(x.opomba)
        data.push(x.opomba);
    return data.join(", ");
}


@Component({ components: { QInput, QCard, QCardSection, QForm, QSelect, QBtn, QSeparator, QLinearProgress, Checkmark, QCheckbox, QItem, QItemSection, QOptionGroup } })
export default class Prijavnica extends Vue {
    private prijavnica = getEmptyData();
    private inProgress = false;
    private predmetLoading = false;
    private completed = false;
    private obmocneEnote: IEnotaZrss[] = [];
 private finished = true;
    private ustanove = [] as any;
    private zavodiFiltered = [];
    private potrditevPogojev = false;
    private lastZavodNeedle = "";
    private zavodi: any[] = [];
    private izvedbe: ISeminarSS[] = [];

    private mounted() {
        this.inProgress = true;
        //GetEnoteZrss().then(a => this.obmocneEnote = a.data).finally(() => this.inProgress = false);
        import("@/data/zavodi").then(d => this.zavodi = d.default).finally(() => this.inProgress = false);
        //import("@/data/izvedbe_os").then(d => this.izvedbe = d.default);

    }

    get predmeti() {
        return [...new Set(this.izvedbe.filter(iz => iz.nivoKratica === this.prijavnica.seminar.nivo).map(iz => iz.predmet))].sort();
    }

    get skupine() {

        const data = this.izvedbe.filter(iz => iz.nivoKratica === this.prijavnica.seminar.nivo && iz.predmet === this.prijavnica.seminar.predmet).map(iz => ({ label: `${iz.datum} ${iz.ura || ""} (${formatSkupinaOpomba(iz)})`, value: iz.id, seminar: iz }));
        const grouped = data.reduce((agg, curr) => {
            if (!agg[curr.label]) agg[curr.label] = curr;
            else if (agg[curr.label].value.kanal > curr.seminar.kanal) {
                agg[curr.label] = curr;
            }
            return agg;
        }, {} as any);
        return Object.values(grouped);
    }

    get lahkoOddaPrijavo() {

        if (!this.potrditevPogojev) return false;
        if (!this.prijavnica.ustanova.naziv) return false;
        if (!this.prijavnica.ustanova.naslov) return false;
        if (!this.prijavnica.ustanova.posta) return false;
        if (!this.prijavnica.udelezenec.ime) return false;
        if (!this.prijavnica.udelezenec.priimek) return false;
        if (!this.prijavnica.udelezenec.email) return false;
        if (!this.prijavnica.udelezenec.email1) return false;
        if (!this.prijavnica.seminar.nivo) return false;
        if (!this.prijavnica.seminar.predmet) return false;
        if (!this.prijavnica.seminarId) return false;
        if (!this.prijavnica.udelezenec.letoRojstva) return false;
        return true;
    }


    private async submit() {

        try {
            this.inProgress = true;
            const data = {...this.prijavnica, ustanova: { ...this.prijavnica.ustanova, postna: this.prijavnica.ustanova.posta}};
            const res = await PostPrijavnicaStudijske(data);
            this.$q.notify({
                message: 'Prijava uspešno oddana',
                caption: ' Potrditev prijave boste prejeli na e-mail naslov.',
                position: 'top',
                color: 'positive',
                icon: 'announcement'
            });
            this.completed = true;
        } catch {
            this.$q.notify({
                message: 'NAPAKA!',
                caption: ' Pri oddaji zahtevka je prišlo do napake. Prosim poizkusite ponovno.',
                position: 'top',
                color: 'negative',
                icon: 'announcement'
            });
        }
        finally {
            this.inProgress = false;

        }

    }
    private setUstanova(data: any) {
        console.log(data);
        data = {...data};
        if(!data.naslov) data.allowEditing = true;
        this.prijavnica.ustanova = data;
    }

    private setNivo(data: any) {
        this.prijavnica.seminar.predmet = null;
        if ((this.$refs.predmet as any))
            (this.$refs.predmet as any).resetValidation();
        this.prijavnica.seminarId = null;
        this.inProgress = true;
        this.predmetLoading = true;

        GetSeminarjiStudijske(data).then(a => this.izvedbe = a.data)
            .then(() => {
                if (this.predmeti.length === 1) {
                    this.prijavnica.seminar.predmet = this.predmeti[0] as any;

                }
            })
            .finally(() => {
                this.inProgress = false;
                this.predmetLoading = false;
            });
    }

    private setPredmet(data: string) {
        console.log(data);
        //GetSeminarjiStudijske().then(a => this.izvedbe = a.data).finally(() => this.inProgress = false);
    }

    private zavodiFilter(val: string, update: (fn: () => void) => void, abort: () => void) {


        update(() => {
            const needle = val.toLocaleLowerCase();
            if (this.lastZavodNeedle && needle.startsWith(this.lastZavodNeedle)) {
                const regexNeedle = "(?=.*" + needle.split(" ").join(")(?=.*") + ")";
                console.log(regexNeedle);
                this.zavodiFiltered = this.zavodiFiltered.filter((v: any) => v.naziv.toLocaleLowerCase().match(regexNeedle));
            } else {
                const regexNeedle = "(?=.*" + needle.split(" ").join(")(?=.*") + ")";
                this.zavodiFiltered = this.zavodi.filter(v => v.naziv.toLocaleLowerCase().match(regexNeedle)) as any;
            }

            this.lastZavodNeedle = needle;
        });
    }

}
